import { getConfig } from '@/shared/config/rewardsShop'
import { useDigitalProductContextOptional } from '@/shared/contexts/DigitalProductContext'
import { useAppRouter } from '@/shared/hooks/useAppRouter'
import { useRewardGainActivityStore } from '@/shared/store/rewardGainActivityStore'
import { useIsDialogOpen } from '@/shared/ui/dialog'
import { isLevelPlayRoute } from '@/shared/ui/Layout/shells/PassthroughShell'

/**
 * `true` quando o popup pode abrir agora (R8): fora de gameplay, fora da
 * vitrine, sem badge de ganho em exibição e sem dialog imperativo aberto.
 * Um lote com gate fechado espera — nunca é descartado.
 */
export const useStoreNudgeGate = (): boolean => {
  const { pathname } = useAppRouter()
  const contexto = useDigitalProductContextOptional()
  const badgeActive = useRewardGainActivityStore(s => s.active)
  const dialogOpen = useIsDialogOpen()

  const basePathWithId = contexto?.config?.basePathWithId ?? ''
  const storeBasePath = getConfig({
    digitalProductId: contexto?.digitalProductId
  }).basePath
  const localPath = basePathWithId ? pathname.replace(basePathWithId, '') : pathname

  if (isLevelPlayRoute(pathname)) return false
  if (localPath.startsWith(storeBasePath)) return false
  if (badgeActive) return false
  if (dialogOpen) return false
  return true
}
